var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iv-auto-transition',{attrs:{"step":_vm.step,"type":"iv-direction-slide"}},[(_vm.isChildRoute())?_c('div',{key:"route"},[_c('iv-fade-slide',[_c('router-view')],1)],1):[_vm._l((_vm.$slots),function(_,slot){return _vm._t(slot)})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }